<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="userId" >
        <span slot="label" >
          <a-tooltip>
            {{$t('分佣记录.收到奖励的人')}}<template slot="title">{{$t('分佣记录.收到奖励的人')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.userId"  :placeholder="$t('通用.输入.请输入')+$t('分佣记录.收到奖励的人')" />
      </a-form-model-item>
      <a-form-model-item prop="orderUserId" >
        <span slot="label" >
          <a-tooltip>
            {{$t('分佣记录.购物人')}}<template slot="title">{{$t('分佣记录.购物人')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.orderUserId"  :placeholder="$t('通用.输入.请输入')+$t('分佣记录.购物人')" />
      </a-form-model-item>
      <a-form-model-item prop="giftNum" >
        <span slot="label" >
          <a-tooltip>
            {{$t('分佣记录.奖励数量')}}<template slot="title">{{$t('分佣记录.奖励数量')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.giftNum"  :placeholder="$t('通用.输入.请输入')+$t('分佣记录.奖励数量')" />
      </a-form-model-item>
      <a-form-model-item prop="commType" >
        <span slot="label" >
          <a-tooltip>
            {{$t('分佣记录.奖励类型：直推用户roleUser1，间推用户roleUser2，直推营养师roleUser1，间推营养师roleUser1')}}<template slot="title">{{$t('分佣记录.奖励类型：直推用户roleUser1，间推用户roleUser2，直推营养师roleUser1，间推营养师roleUser1')}}</template>
          </a-tooltip>
        </span>
      </a-form-model-item>
      <a-form-model-item prop="giftRate" >
        <span slot="label" >
          <a-tooltip>
            {{$t('分佣记录.奖励比例')}}<template slot="title">{{$t('分佣记录.奖励比例')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.giftRate"  :placeholder="$t('通用.输入.请输入')+$t('分佣记录.奖励比例')" />
      </a-form-model-item>
      <a-form-model-item prop="orderNo" >
        <span slot="label" >
          <a-tooltip>
            {{$t('分佣记录.订单编号')}}<template slot="title">{{$t('分佣记录.订单编号')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.orderNo" :maxLength="24" :placeholder="$t('通用.输入.请输入')+$t('分佣记录.订单编号')" />
      </a-form-model-item>
      <a-form-model-item prop="orderId" >
        <span slot="label" >
          <a-tooltip>
            {{$t('分佣记录.附属订单id')}}<template slot="title">{{$t('分佣记录.附属订单id')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.orderId" :maxLength="24" :placeholder="$t('通用.输入.请输入')+$t('分佣记录.附属订单id')" />
      </a-form-model-item>
      <a-form-model-item prop="orderItemId" >
        <span slot="label" >
          <a-tooltip>
            {{$t('分佣记录.订单条目id')}}<template slot="title">{{$t('分佣记录.订单条目id')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.orderItemId"  :placeholder="$t('通用.输入.请输入')+$t('分佣记录.订单条目id')" />
      </a-form-model-item>
      <a-form-model-item prop="remark" >
        <span slot="label" >
          <a-tooltip>
            {{$t('分佣记录.备注')}}<template slot="title">{{$t('分佣记录.备注')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.remark" :placeholder="$t('通用.输入.请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video style="width: 100%" :src="previewUrl" ref="myVideo"
               :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'" :controls="true"></video>
      </a-modal>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getUserGoodsLog, addUserGoodsLog, updateUserGoodsLog } from '@/api/comm/userGoodsLog'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      // 表单参数
      form: {
        id: null,

        userId: null,

        orderUserId: null,

        giftNum: null,

        commType: null,

        giftRate: null,

        orderNo: null,

        orderId: null,

        orderItemId: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        orderUserId: null,
        giftNum: null,
        commType: null,
        giftRate: null,
        orderNo: null,
        orderId: null,
        orderItemId: null,
        createTime: null,
        remark: null,
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getUserGoodsLog({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateUserGoodsLog(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('通用.文本.修改成功')
            addUserGoodsLog(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
